import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Home from "@/pages/Home";
import Events from "@/pages/Events";
import EventDetails from "@/pages/EventDetails";
import Cart from "@/pages/Cart";
import Profile from "@/pages/Profile";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import Tickets from "@/pages/Tickets";
import Navbar from "@/Components/Navbar";
import Footer from "@/Components/Footer";
import PasswordRescue from "../pages/PasswordRescue";
import ChangePassword from "../pages/ChangePassword";
import Pending from "../pages/Pending";
import Failure from "../pages/Failure";
import ScrollToTop from "../Components/ScrollToTop";
import ProducersPage from "../pages/ProducersPage";

const AppRoutes = () => {
    return (
        <Router>
            <Navbar/>
            <ScrollToTop/>
            <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/eventos" element={<Events />} />
                <Route path="/eventos/:slug" element={<EventDetails />} />
                <Route path="/tickets" element={<Tickets />} />
                <Route path="/carrito" element={<Cart />} />
                <Route path="/profile" element={<Profile />} />
                <Route path="/login" element={<Login />} />
                <Route path="/register" element={<Register />} />
                <Route path="/rescue-pass" element={<PasswordRescue />} />
                <Route path="/change_password" element={<ChangePassword />} />
                <Route path="/pending" element={<Pending />} />
                <Route path="/failure" element={<Failure />} />
                <Route path="/producers" element={<ProducersPage />} />
            </Routes>
            <Footer/>
        </Router>
    );
};

export default AppRoutes;
